import styled from 'styled-components'

export const HeaderTitle = styled.div`
  flex: 1;
  height: 80px;
  background-color: ${props => props.room };
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`
export const HomeReportTitle = styled.div`
	margin-left: 10px;
  margin-bottom: 12px;
  font-size:17px;
  font-weight:bold;
  @media (max-width: 763px) {
    font-size: 11px;
    margin-bottom:3px;
  }
`

export const NameHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-top: 8px;
`
export const Close = styled.div`
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
`
export const Save = styled.div`
  width: 150px;
  height: 100%;
  display: flex;
  justify-content: center;
  top: 0;
  align-items: center;
  position: absolute;
  right: 0;
  @media (max-width: 763px) {
    width: 100px;
  }
`

export const NameSpan = styled.span`
  color: #4A4A4A;
`

export const HeaderSpan = styled.div`
  color: #FFFFFF;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`

export const Img = styled.img`
  padding: 16px;
  cursor: pointer;
  width: 30px;
  height: 30px;
`
export const Content = styled.div`
  flex: 1;
  height: 600px;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 30px;
`
export const TemperatureContainer = styled.div`
  width: 100%;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 35px;
  margin-top: 50px;
  padding: 10px;
`

export const TemperatureDiv = styled.div`
  width: 80%;
  height: 100px;
  background-color: #E2E8EC;
  border-radius: 4px;
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  @media (max-width: 763px) {
    height: 70px;
  }
`
export const TemperatureText = styled.div`
  width: 150px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (max-width: 763px) {
    width: 70px;
  }
`
export const TemperatureNumber = styled.span`
  font-size: 30px;
  @media (max-width: 763px) {
    font-size: 15px;
  }
`
export const Span = styled.div`
  font-size: 15px;
  margin-bottom: 2px;
  @media (max-width: 763px) {
    font-size: 9px;
    margin-left: 10px;
  }
`
export const SpanHomeReport = styled.div`
  font-size: 15px;
  margin-bottom: 2px;
  @media (max-width: 763px) {
    font-size: 9px;
    margin-left: 10px;
  }
`

export const TemperatureSlider = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const SliderDiv = styled.div`
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

 export const Question = styled.div`
  width: 95%;
  height: 50px;
  border-radius: 5px;
  margin-bottom: 5px;
  margin-top: 5px;
  border: solid 1px #CCCCCC;
  display: flex;
  justify-content:flex-start;
  align-items: center;
  background-color: ${props => props.selected ? '#4A90E2' : ''};
  color: ${props => props.selected ? '#FFF' : ''};
`

export const IconsDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export const Check = styled.img`
    width: 23px;
    height: 23px;
    margin-right: 10px;
`
export const ActionButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 30px;
  padding: 16px;
  cursor: pointer;
`

export const ReviseDiv = styled.div`
  width: 50%;
  height: 100%;
  flex-direction: column;
  @media (max-width: 763px) {
    width: 100%;
    height: auto;
  }

`

export const DivAskParent = styled.div`
  width: 50%;
  height: 100%;
  flex-direction: column;
  @media (max-width: 763px) {
    width: 100%;
    height: auto;
  }
`
export const DivAskTeacher = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
  @media (max-width: 763px) {
    width: 100%;
    height: auto;
  }
`

export const QuestionsContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 100px;
`
export const QuestionsTeacherContainer = styled.div`
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 100px;
  @media (max-width: 763px) {
    margin-bottom: 0px;
  }
`

export const QuestionsDiv = styled.div`
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: row;
  @media (max-width: 763px) {
    flex-direction: column;
    height: calc(70vh - 100px);
    display: block;
  }

`

export const SwitchContainer = styled.div`
 width: 100%;
 height: auto;
 bottom: 0;
 flex-direction: column;
 display: flex;
 align-items: center;
 padding-bottom:20%;
 @media (max-width: 763px) {
   margin-top: 350px;
   margin-bottom: 50px;
 }
`
export const SwitchTeacherContainer = styled.div`
 width: 100%;
 height: auto;
 bottom: 0;
 flex-direction: column;
 display: flex;
 align-items: center;
 padding-bottom:20%;
 @media (max-width: 763px) {
   margin-top: 0px;
   margin-bottom: 50px;
 }
`

export const SwitchDiv = styled.div`
  width: 80%;
  min-height: 100px;
  background-color: #F0F0F0;
  border-radius: 4px;
  border: solid 1px #CCCCCC;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: -30px;
  padding: 8px;

  @media (max-width: 763px) {
    min-height: 70px;
  }
`
export const SwitchTopDiv = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  flex-direction: row;
`
export const Observations = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
`
export const Textarea = styled.textarea`
  width: 95%;
  height: 25px;
  margin-left: 10px;
  background-color: transparent;
  border: solid #CCCCCC 1px;
  visibility: ${props => props.disabled ? 'hidden' : 'visible'};
  @media (max-width: 763px) {
    font-size: 8px;
    width: 90%;
    height: 20px;
  }
`
export const SelectContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 20px;
`

export const ParentContainer = styled.div`
  width: 100%;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -10px;
  padding: 10px;
`

export const ParentDiv = styled.div`
  width: 80%;
  height: 80px;
  background-color: #E2E8EC;
  border-radius: 4px;
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  font-weight: bold;
  color: #4c4c4c;
  @media (max-width: 763px) {
    height: 70px;
  }
`
export const HomeReportContainer = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: -10px;
  margin-top: 30px;
  padding: 10px;
`

export const HomeReportDiv = styled.div`
  width: 80%;
  height: 150px;
  background-color: #E2E8EC;
  border-radius: 4px;
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  color: #4c4c4c;
  @media (max-width: 763px) {
    height: 70px;
  }
`
export const HomeReportDiv2 =styled.div`
`

export const SwitchParentContainer = styled.div`
  width: 100px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
`
export const SwitchOptions = styled.div`
width: 50%;
height: 40px;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
`
export const SwitchYes = styled(SwitchOptions)`
  background-color: ${props => props.active ? '#75B753' : '#b9b9b9'};
  color: ${props => props.active ? '#FFFFFF' : '#4A4A4A'};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`

export const SwitchNo = styled(SwitchOptions)`
  background-color: ${props => props.active ? '#C50315' : '#b9b9b9'};
  color: ${props => props.active ? '#FFFFFF' : '#4A4A4A'};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`



// WEBPACK FOOTER //
// ./src/Components/ModalContainer/ModalAssessment.styles.jsx